
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mindprint",
      function () {
        return require("private-next-pages/mindprint.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mindprint"])
      });
    }
  